import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Enveloppe commune aux pages publiques (aide, contact, suivi, mentions).
 * Reprend l'en-tête et le pied de page de l'accueil, et pose un bandeau de
 * titre au même langage visuel que le hero : fond bleu nuit, tracés de routes,
 * fil d'Ariane. Les pages n'ont plus qu'à fournir leur contenu.
 */
const PublicPageShell = ({ title, lede, eyebrow, children }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  // Les ancres appartiennent à l'accueil : depuis une page interne, on y retourne.
  const goToSection = (id) => navigate(`/#${id}`);

  return (
    <div className="landing-public-page">
      <Navbar scrollTo={goToSection} anchors={false} />

      <header className="landing-page-hero">
        <div className="landing-page-hero-inner">
          <nav className="landing-breadcrumb" aria-label={t('breadcrumbLabel')}>
            <button type="button" onClick={() => navigate('/')}>{t('breadcrumbHome')}</button>
            <ChevronRight size={13} aria-hidden="true" />
            <span aria-current="page">{title}</span>
          </nav>
          {eyebrow && <span className="landing-page-hero-eyebrow">{eyebrow}</span>}
          <h1>{title}</h1>
          {lede && <p>{lede}</p>}
        </div>
      </header>

      <main className="landing-page-body">{children}</main>

      <Footer scrollTo={goToSection} />
    </div>
  );
};

export default PublicPageShell;
